import React from 'react';
import { Flex, Text, Button, Pane } from '@leverege/ui-elements';
import S from '../PairingFlow.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function DefaultResult(props) {
  const {
    message,
    pairing,
    selling,
    trackerId,
    assetId,
    error,
    type,
    onClick
  } = props;
  return /*#__PURE__*/_jsxs(React.Fragment, {
    children: [/*#__PURE__*/_jsx("img", {
      className: S.successImage,
      width: 120,
      height: 120,
      alt: message,
      src: `https://recovr-ui-assets.storage.googleapis.com/pairing-${type}.png`
    }), /*#__PURE__*/_jsxs(Flex, {
      variant: "colXL",
      align: "center",
      children: [/*#__PURE__*/_jsx(Text, {
        variant: "formTitle",
        children: message
      }), /*#__PURE__*/_jsx(ErrorMessage, {
        pairing: pairing,
        trackerId: trackerId,
        assetId: assetId,
        error: error
      }), type === 'success' && /*#__PURE__*/_jsxs("div", {
        className: S.buttonContainer,
        children: [/*#__PURE__*/_jsx(Button, {
          variant: "fakeList",
          eventData: "tracker",
          onClick: onClick,
          children: `Locator ${trackerId}`
        }), pairing && /*#__PURE__*/_jsx(Button, {
          variant: "fakeList",
          eventData: "asset",
          onClick: onClick,
          children: `Vehicle ${assetId}`
        }), selling && /*#__PURE__*/_jsx(Button, {
          variant: "fakeList",
          eventData: "sale",
          onClick: onClick,
          children: `Sale ${assetId}`
        })]
      }), type === 'failure' && /*#__PURE__*/_jsxs("div", {
        className: S.buttonContainer,
        children: [/*#__PURE__*/_jsx(Button, {
          variant: "fakeList",
          eventData: "tracker",
          onClick: onClick,
          children: `Locator ${trackerId}`
        }), pairing && /*#__PURE__*/_jsx(Button, {
          variant: "fakeList",
          eventData: "asset",
          onClick: onClick,
          children: `Vehicle ${assetId}`
        })]
      })]
    })]
  });
}
function ErrorMessage(props) {
  const {
    error,
    pairing,
    trackerId,
    assetId
  } = props;
  if (!error) {
    return null;
  }
  let message;
  if (error.status === 400) {
    message = /*#__PURE__*/_jsxs(Text, {
      children: ["Locator ", /*#__PURE__*/_jsx("b", {
        children: trackerId
      }), " was unable to pair with vehicle ", /*#__PURE__*/_jsx("b", {
        children: assetId
      }), ". Please unpair the locator from any other vehicles and try again."]
    });
  } else if (error.status === 403) {
    message = /*#__PURE__*/_jsxs(Text, {
      children: ["Locator ", /*#__PURE__*/_jsx("b", {
        children: trackerId
      }), " was unable to ", pairing ? 'pair' : 'unpair', " with vehicle ", /*#__PURE__*/_jsx("b", {
        children: assetId
      }), ". You do not have permission to perform this action."]
    });
  } else if (error.status === 404) {
    message = /*#__PURE__*/_jsxs(Text, {
      children: ["Locator ", /*#__PURE__*/_jsx("b", {
        children: trackerId
      }), " was unable to unpair because it is not currently paired."]
    });
  } else if (error.status === 500) {
    message = /*#__PURE__*/_jsx(PairErrorDetail, {
      message: error.message
    });
  } else {
    message = /*#__PURE__*/_jsxs(Text, {
      children: ["Locator ", /*#__PURE__*/_jsx("b", {
        children: trackerId
      }), " was unable to ", pairing ? 'pair' : 'unpair', " with vehicle ", /*#__PURE__*/_jsx("b", {
        children: assetId
      }), " because of a network connection failure"]
    });
  }
  return /*#__PURE__*/_jsx(Flex, {
    variant: "colM",
    children: message
  });
}
function PairErrorDetail({
  message
}) {
  return /*#__PURE__*/_jsx(Pane, {
    variant: "dashboardCard",
    children: /*#__PURE__*/_jsx(Pane, {
      variant: "dataCard",
      children: /*#__PURE__*/_jsxs(Flex, {
        variant: "rowS",
        children: [/*#__PURE__*/_jsx("img", {
          width: 25,
          height: 25,
          src: "https://recovr-ui-assets.storage.googleapis.com/icon-system-error-2x.png",
          alt: "Error"
        }), /*#__PURE__*/_jsx("div", {
          style: {
            flexGrow: 1
          },
          children: /*#__PURE__*/_jsx(Text, {
            children: message
          })
        })]
      })
    })
  });
}